import { Link, useLocation } from 'wouter';
import { CalendarDays, Radio, Settings } from 'lucide-react';
import { cn } from '@/lib/utils';

const tabs = [
  { href: '/schedule', label: 'Schedule', icon: CalendarDays },
  { href: '/live', label: 'Live', icon: Radio },
  { href: '/settings', label: 'Settings', icon: Settings },
] as const;

export function TabBar() {
  const [location] = useLocation();

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 pb-safe"
      style={{
        background: 'var(--color-surface)',
        borderTop: '1px solid var(--color-border)',
      }}
      aria-label="Main navigation"
    >
      <div className="flex items-center justify-around h-14 max-w-lg mx-auto">
        {tabs.map(({ href, label, icon: Icon }) => {
          const isActive = location === href || location.startsWith(href + '/');
          return (
            <Link key={href} href={href}>
              <button
                className={cn(
                  'touch-target flex flex-col items-center justify-center gap-0.5 px-6 rounded-lg transition-colors',
                  isActive
                    ? 'text-[var(--color-primary)]'
                    : 'text-[var(--color-text-secondary)] hover:text-[var(--color-text)]'
                )}
                aria-label={label}
                aria-current={isActive ? 'page' : undefined}
              >
                <Icon
                  size={22}
                  strokeWidth={isActive ? 2.5 : 1.75}
                />
                <span
                  className="text-[10px] font-medium leading-none"
                  style={{ fontFamily: 'var(--font-body)' }}
                >
                  {label}
                </span>
              </button>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
